var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3161 15.5488H29.6588V22.7737C29.6588 23.8986 29.0038 24.9157 27.6908 24.9157H14.8262V25.2592C14.8262 26.2537 15.9574 27.2576 17.119 27.2576H26.9546L30.7174 29.47L30.1717 27.2576H30.3161C31.477 27.2576 32.0008 26.2561 32.0008 25.2592V17.2639C32.0008 16.2694 31.477 15.5488 30.3161 15.5488Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7695 10.5293H10.8276C9.51293 10.5293 8 11.6971 8 12.8228V21.8782C8 22.9149 9.28185 23.6636 10.5114 23.7791L9.71122 26.8166L14.8386 23.8002H25.7695C27.0841 23.8002 28.2973 23.0031 28.2973 21.8782V14.5519V12.8228C28.2973 11.6971 27.0834 10.5293 25.7695 10.5293ZM13.1071 18.1733C12.3616 18.1733 11.7573 17.5691 11.7573 16.8236C11.7573 16.0781 12.3616 15.4739 13.1071 15.4739C13.8519 15.4739 14.4569 16.0781 14.4569 16.8236C14.4569 17.5691 13.8519 18.1733 13.1071 18.1733ZM18.1487 18.1733C17.4031 18.1733 16.7989 17.5691 16.7989 16.8236C16.7989 16.0781 17.4031 15.4739 18.1487 15.4739C18.8942 15.4739 19.4984 16.0781 19.4984 16.8236C19.4984 17.5691 18.8942 18.1733 18.1487 18.1733ZM23.191 18.1733C22.4454 18.1733 21.8404 17.5691 21.8404 16.8236C21.8404 16.0781 22.4454 15.4739 23.191 15.4739C23.9349 15.4739 24.5407 16.0781 24.5407 16.8236C24.5407 17.5691 23.9349 18.1733 23.191 18.1733Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.84ee764c4843a781419f42ed333c5634.svg";
export { ForwardRef as ReactComponent };